<template>
  <div class="zds-order-detail">
    <el-row>
      <el-col :span="8">
        <div>订单编号：{{ model.soNo }}</div>
      </el-col>
      <el-col :span="8">
        <div>订单创建时间：{{ model.gmtCreate }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <div>商品总价：{{ formatPrice(model.totalAmount) }}</div>
      </el-col>
      <el-col :span="8">
        <div>运费：{{ formatPrice(model.freightAmount) }}</div>
      </el-col>
      <el-col :span="8">
        <div>优惠券：{{ formatPrice(model.totalDiscountAmount) }}</div>
      </el-col>
    </el-row>
    <div class="total-summary">
      共 <span class="strong">1</span> 件商品，实付金额：
      <span class="strong">{{ formatPrice(model.totalPaymentAmount) }}</span>
    </div>
    <div class="sub-title">订单明细</div>
    <el-table
      ref="tableRef"
      :data="model.items || []"
      border
    >
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="skuCode" label="商品编码" align="center"></el-table-column>
      <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
      <el-table-column label="商品规格" align="center">
        <template v-slot="{ row }">
          {{ formatSpecAttrJsonListFilter(row.specAttrJson) }}
        </template>
      </el-table-column>
      <el-table-column label="单价" align="center">
        <template v-slot="{ row }">
          {{ formatPrice(row.purchasePrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="buyQty" label="数量" align="center"></el-table-column>
      <el-table-column prop="discountAmount" label="优惠券抵扣" align="center">
        <template v-slot="{ row }">
          {{ formatPrice(row.discountAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="payableAmount" label="实付金额" align="center">
        <template v-slot="{ row }">
          {{ formatPrice(row.payableAmount) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup lang="ts">
import { ref, formatter } from '@zto/zpage';
import { formatPrice } from '@/utils/math'

const props = withDefaults(
  defineProps<{
    model: any
  }>(),
  {
    model:{}
  }
)

const formatSpecAttrJsonListFilter = (val:string) => {
  try {
    if (!val) return '--'
    const specAttrJson = JSON.parse(val)
    return specAttrJson.map((item:any) => item.valueName).join('，')
  } catch (e) {
    return '--'
  }
}



</script>

<style scoped lang="scss">
.zds-order-detail{
  padding-top: 20px;
  //border-right: 20px solid #000;

  .total-summary{
    //margin-bottom: 20px;
    .strong{
      font-weight: bold;
      color: #f40;
    }
  }
  .sub-title{
    font-weight: bold;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    &::before{
      content: '';
      width: 4px;
      height: 16px;
      margin-right: 8px;
      background-color: var(--primary);
      border-radius: 8px;
    }
  }
}
</style>